module.exports = __webpack_public_path__ + "img/9788954438278.0586bd76.jpg";